import { GlobalStyles } from '@mui/material';

const FontStyles = () => (
  <GlobalStyles
    styles={`  
      @font-face {
        font-family: 'BrandonGrotesque';
        font-style: normal;
        font-weight: 500;
        src: local('BrandonGrotesque-Medium'), url('/fonts/brandon-grotesque/HvDTrial_Brandon_Grotesque_medium-BF64a625c84a521.woff2') format('woff2');
        font-display: swap;
        ascent-override: 90%;
        descent-override: 20%;
        line-gap-override: 0%;
      }

      @font-face {
        font-family: 'Gilroy';
        font-style: normal;
        font-weight: 900;
        src: local('Gilroy-Black'), url('/fonts/Gilroy/Gilroy-Black.ttf') format('truetype');
        font-display: swap;
        ascent-override: 90%;
        descent-override: 20%;
        line-gap-override: 0%;
      }

      @font-face {
        font-family: 'Gilroy';
        font-style: normal;
        font-weight: 700;
        src: local('Gilroy-Bold'), url('/fonts/Gilroy/Gilroy-Bold.woff2') format('woff2');
        font-display: swap;
        ascent-override: 90%;
        descent-override: 20%;
        line-gap-override: 0%;
      }

      @font-face {
        font-family: 'Gilroy';
        font-style: normal;
        font-weight: 400;
        src: local('Gilroy-Regular'), url('/fonts/Gilroy/Gilroy-Regular.woff2') format('woff2');
        font-display: swap;
        ascent-override: 90%;
        descent-override: 20%;
        line-gap-override: 0%;
      }`}
  />
);

export default FontStyles;
